<!--在途详情列表-->
<template>

  <div>
    <van-nav-bar :title="title" v-if="titleShow">
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="哥哥找过了,没有更多了,爱宝爱宝"
          loading-text="宝不着急,哥哥正在找,嗷呜~"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
      >
        <van-swipe-cell v-for="item in list" :key="item.transFinId">

          <van-cell >

            <!-- 使用 title 插槽来自定义标题 -->
            <template slot="title">
              <van-row type="flex" justify="space-between">
                <van-col span="11" >
                  <span style="font-size: 20px">{{splitDate(item.inputDate)}}</span>
                  <span> {{splitTime(item.inputDate)}}</span>
                </van-col>
                <van-col span="6">
                  <van-tag  plain  :type="getFinType(item.finType)" style="float: right;">{{item.finTypeName}}</van-tag>
                  <van-tag  plain  type="warning" style="float: right;">{{item.transTypeName}}</van-tag>
                </van-col>
                <van-col span="7">
                  <span style="font-size: 20px">￥{{item.amount}}</span>
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="24" >
                  <span style="float: left;color:#969799;font-size: 12px">{{item.remark}}</span>
                </van-col>
              </van-row>
            </template>

          </van-cell>
          <template slot="right" v-if="item.transType == busiConsts.BILL_TYPE_STORED_VALUE">
            <van-button square plain type="danger" text="删除" class="upd-button" @click="removeFin(item.transFinId,item.finId,item.transType)"/>
          </template>
          <template slot="right" v-if="item.transType == busiConsts.BILL_TYPE_OVERDRAFT">
            <van-button square plain type="danger" text="删除" class="upd-button" @click="removeFin(item.transFinId,item.finId,item.transType)"/>
          </template>
        </van-swipe-cell>
      </van-list>

    </van-pull-refresh>

  </div>

</template>

<script>
import * as MyApi from '../../api/URLApiAddr.js'
import * as BusiConsts from '../../common/BusiConsts.js'

export default {
  name: 'TransFinListDetail.vue',
  components: {
  },
  props:{
    qryData:{
      type: Object
    },
    refreshIndex:{
      default: 1,
      type: Number
    },
    titleIsShow:{
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      title: '在途账单详情',
      titleShow: this.titleIsShow,
      busiConsts: BusiConsts,
      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      tagType: "danger",
      pageInfo:{
        finId: this.qryData['finId'],
        transType: this.qryData['billType'],
        current:1,
        size:10,
        total:-1
      },
      popupShow: false
    }
  },
  watch:{
    refreshIndex(){
      this.onRefresh()
    }
  },

  methods: {
    onLoad() {
      this.pageInfo.finId = this.qryData['finId'],
          this.pageInfo.transType = this.qryData['billType']

      if (this.refreshing) {
        this.list = [];
        this.pageInfo.current = 1
        this.pageInfo.total=-1
        this.refreshing = false
      }

      let ths = this
      if(this.list.length == this.pageInfo.total){
        this.finished = true;
        return false
      }
      let params = this.pageInfo
      this.$axios.post(MyApi.QRY_TRANS_FIN_DETAIL_LIST,params/*,options*/)
          .then((response) =>  {
            debugger
            let code = response.code;
            if(code == '200'){

              let data = response.data
              if(data.records.length >0){
                ths.pageInfo.current ++

                //ths.list = data.records
                ths.list = ths.list.concat(data.records)
                ths.pageInfo.total = data.total;
                if(ths.list.length == data.records.total){
                  this.finished = true;
                }

              }else{
                this.finished = true;
              }
            }
            this.loading = false;

          })
          .catch((err) =>{
            this.loading = false
            this.error = true
            this.$toast.fail("数据初始化异常"+err);
          })

    },
    splitDate(inputDate) {
      return inputDate.substr(0,10)
    },
    splitTime(inputDate) {
      return inputDate.substr(11,5)
    },
    getFinType(finType,finTypeName){
      if(finType == '12101'){
        return "danger"
      }else{
        return  "primary"
      }
      //return finTypeName
    },
    onRefresh() {
      debugger
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    alterFin(transFinId){
      this.$router.push({ name:'tranceFinanceDetail',params:{transFinId:transFinId} })
    },
    removeFin(transFinId,finId,transType){
      this.$dialog.confirm({
        title: '删除',
        message: '确认删除该在途数据数据吗？'
      }).then(() => {
        let params = {"transFinId":transFinId,"finId":finId,"transType":transType}
        this.$axios.post(MyApi.TRANS_FIN_DETAIL_DEL_URL,params/*,options*/)
            .then((response) =>  {
              debugger
              let code = response.code;
              if(code == '200'){
                this.$toast.success(response.msg);
                // 清空列表数据
                this.finished = false;
                this.refreshing = true;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
              }
            })
            .catch((err) =>{
              this.$toast.fail("删除异常"+err);
            })

      }).catch(() => {

      });
    }
  }

}


</script>

<style scoped="scoped">
.upd-button {
  height: 100%;
}
.van-list >>> .van-list__finished-text{
  margin-bottom: 50px;
}


</style>
